import { render, staticRenderFns } from "./HistoryTimelineEv.vue?vue&type=template&id=38b9640d&lang=pug&"
import script from "./HistoryTimelineEv.vue?vue&type=script&lang=ts&"
export * from "./HistoryTimelineEv.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryTimelineEv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCol,VImg,VRow,VTimeline,VTimelineItem})
